"use client";

import React from "react";
import { Loader, CircleCheck, CircleAlert } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center bg-card border border-primary/20 rounded-sm shadow-lg">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
          <CircleCheck className="w-8 h-8 text-primary" />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-2 font-serif">Bericht Verzonden</h3>
        <p className="text-muted-foreground mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-sm uppercase tracking-wider text-xs font-bold">
          Nieuw bericht sturen
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Naam is verplicht"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary text-xs font-bold uppercase tracking-wider">
                Naam
              </FormLabel>
              <FormControl>
                <Input placeholder="Jan Jansen" className="bg-card border-border focus-visible:ring-primary focus-visible:border-primary rounded-sm text-foreground placeholder:text-muted-foreground/50 h-12" {...field} />
              </FormControl>
              <FormDescription className="text-xs text-muted-foreground">
                Vul uw volledige naam in.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "E-mailadres is verplicht",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Ongeldig e-mailadres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary text-xs font-bold uppercase tracking-wider">
                E-mailadres
              </FormLabel>
              <FormControl>
                <Input type="email" placeholder="jan@example.com" className="bg-card border-border focus-visible:ring-primary focus-visible:border-primary rounded-sm text-foreground placeholder:text-muted-foreground/50 h-12" {...field} />
              </FormControl>
              <FormDescription className="text-xs text-muted-foreground">
                We nemen via e-mail contact met u op.
              </FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="phone" rules={{}} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary text-xs font-bold uppercase tracking-wider">
                Telefoonnummer <span className="text-muted-foreground lowercase font-normal tracking-normal">(optioneel)</span>
              </FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+31 6 1234 5678" className="bg-card border-border focus-visible:ring-primary focus-visible:border-primary rounded-sm text-foreground placeholder:text-muted-foreground/50 h-12" {...field} />
              </FormControl>
              <FormDescription className="text-xs text-muted-foreground">
                Optioneel, voor een sneller antwoord.
              </FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="subject" rules={{
        required: "Onderwerp is verplicht"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary text-xs font-bold uppercase tracking-wider">
                Onderwerp
              </FormLabel>
              <FormControl>
                <Input placeholder="Bijvoorbeeld: Vraag over kapsel" className="bg-card border-border focus-visible:ring-primary focus-visible:border-primary rounded-sm text-foreground placeholder:text-muted-foreground/50 h-12" {...field} />
              </FormControl>
              <FormDescription className="text-xs text-muted-foreground">
                Kort omschrijven waar uw vraag over gaat.
              </FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Bericht is verplicht",
      minLength: {
        value: 10,
        message: "Bericht moet minimaal 10 karakters bevatten"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary text-xs font-bold uppercase tracking-wider">
              Bericht
            </FormLabel>
            <FormControl>
              <Textarea placeholder="Typ hier uw vraag of opmerking..." className="bg-card border-border focus-visible:ring-primary focus-visible:border-primary rounded-sm text-foreground placeholder:text-muted-foreground/50 min-h-[150px] resize-y" {...field} />
            </FormControl>
            <FormDescription className="text-xs text-muted-foreground">
              Geef zo duidelijk mogelijk uw vraag weer.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-sm flex items-start gap-3">
          <CircleAlert className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm h-14 text-base font-bold uppercase tracking-widest transition-all duration-300 shadow-[0_0_15px_rgba(212,175,55,0.15)] hover:shadow-[0_0_25px_rgba(212,175,55,0.3)]">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 w-5 h-5" />
            Verzenden...
          </> : "Verstuur Bericht"}
      </Button>
    </Form>;
}
export default function StelEenVraag() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}